import React, { PropTypes } from 'react';
import { inject, observer } from "mobx-react";
import { observable, autorun, toJS, action } from 'mobx';
import L from 'leaflet';
// import {leafletURL} from "../config";
import ReactSpinner from 'react-spinner';
import _ from 'lodash';
import "leaflet-fullscreen";
import 'leaflet-semicircle';
import { renderToStaticMarkup } from "react-dom/server";

const events = ['wheel', 'dblclick', 'mousedown', 'mouseup', 'mousemove', 'touchmove', 'touchend']; // these events on map child wont be propagated to child;

@inject('stationStore', 'tagStore', 'mapStore')
@observer
class LeafletMap extends React.Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  map;
  dispose;

  @observable markers = this.props.markers || [];
  @observable circle = null;
  @observable circles = [];
  @observable geojson = null;
  @observable polylines = null;
  @observable markerIcons = [];
  @observable draggables = [];

  @action
  componentDidMount() {
    const { center: { lat, lng }, zoom, id, zoomDelta, zoomSnap, wheelPxPerZoomLevel, maxZoom } = this.props;
    this.map = L.map(id, {
      fullscreenControl: true,
      zoomDelta: zoomDelta || 1,
      zoomSnap: zoomSnap || 1,
      wheelPxPerZoomLevel: wheelPxPerZoomLevel || 60,
    }).setView([lat, lng], zoom || 7);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: maxZoom || 19,
      maxNativeZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map);

    this.dispose = autorun(() => {
      if (!!this.markers || this.markers.length !== 0) this.pushMarkers(toJS(this.markers))
    });

    let mapChildren = document.getElementById(`map-${id}-children`);
    events.forEach(event => {
      mapChildren.addEventListener(event, this.stopPropagation);
    });

    if (this.props.circle) {
      if (Array.isArray(this.props.circle)) {
        this.props.circle.forEach(circle => {
          let { latLng, radius, startAngle, stopAngle } = circle;
          if ((!!startAngle || +startAngle === 0) && (!!stopAngle || +stopAngle === 0) && +startAngle === +stopAngle) {
            startAngle -= 5;
            stopAngle += 5;
          }
          this.circles.push(L.semiCircle(latLng, { radius, startAngle: startAngle || 0, stopAngle: stopAngle || 360 }).addTo(this.map));
          this.map.setView(latLng, zoom || 9);

          setTimeout(() => this.map.invalidateSize(), 100);
        })
      } else {
        let { latLng, radius, startAngle, stopAngle } = this.props.circle;
        if ((!!startAngle || +startAngle === 0) && (!!stopAngle || +stopAngle === 0) && +startAngle === +stopAngle) {
          startAngle -= 5;
          stopAngle += 5;
        }
        this.circle = L.semiCircle(latLng, { radius, startAngle: startAngle || 0, stopAngle: stopAngle || 360 }).addTo(this.map);
        this.map.setView(latLng, zoom || 9);

        setTimeout(() => this.map.invalidateSize(), 100);
      }
    }

    if (this.props.polylines) {
      this.polylines = [];

      this.props.polylines.forEach(polyline => {
        L.polyline(polyline.latLngs.map((latLng) => ({ lat: latLng[0], lng: latLng[1] })), {
          color: polyline.color
        }).addTo(this.map);
      });
    }

    if (this.props.bottomLeftCustomControls) {
      this.props.bottomLeftCustomControls.forEach(this.renderCustomControl("bottomleft"))
    }

    if (this.props.topLeftCustomControls) {
      this.props.topLeftCustomControls.forEach(this.renderCustomControl("topleft"))
    }

    if (this.props.bottomRightCustomControls) {
      this.props.bottomRightCustomControls.forEach(this.renderCustomControl("bottomright"))
    }

    if (this.props.topRightCustomControls) {
      this.props.topRightCustomControls.forEach(this.renderCustomControl("topright"))
    }

    // this.map.on('zoomend', () => {
    //     this.markerIcons.map(({markerIcon}) => {
    //       this.map.removeLayer(markerIcon);
    //       markerIcon.unbindPopup();
    //     });
    //
    //     this.pushMarkers(toJS(this.markers));
    // })

    const div = L.DomUtil.get('overlay');

    if (div) {
      L.DomEvent.on(div, 'mousewheel', L.DomEvent.stopPropagation);
      L.DomEvent.on(div, 'mousemove', L.DomEvent.stopPropagation);
      L.DomEvent.on(div, 'mousedown', L.DomEvent.stopPropagation);
      L.DomEvent.on(div, 'touchdown', L.DomEvent.stopPropagation);
      L.DomEvent.on(div, 'touchmove', L.DomEvent.stopPropagation);
    }
  }

  @action
  componentWillReceiveProps(nextProps) {
    const { lat, lng } = nextProps.center;
    const { center, zoom } = this.props;

    if (this.props.selectedMarker !== nextProps.selectedMarker || !_.isEqual(toJS(this.markers), nextProps.markers)) {
      this.markerIcons.map(({ id, markerIcon }) => {
        this.map.removeLayer(markerIcon);
        // let draggable = this.draggables.find(item => item.id === id);
        // if(!!draggable) this.map.removeLayer(draggable.popup);
        markerIcon.unbindPopup();
      });
      this.markers = [];
      this.markers = nextProps.markers;
    }

    if ((this.props.circle === null && nextProps.circle) || (this.props.circle && nextProps.circle === null) || !_.isEqual(toJS(this.props.circle), toJS(nextProps.circle))) {
      if (this.circle)
        this.map.removeLayer(this.circle);
      if (!!this.circles.length) this.circles.forEach(this.map.removeLayer);

      if (nextProps.circle) {
        if (Array.isArray(nextProps.circle)) {
          nextProps.circle.forEach(circle => {
            let { latLng, radius, startAngle, stopAngle } = circle;
            if ((!!startAngle || +startAngle === 0) && (!!stopAngle || +stopAngle === 0) && +startAngle === +stopAngle) {
              startAngle -= 5;
              stopAngle += 5;
            }
            this.circles.push(L.semiCircle(latLng, { radius, startAngle: startAngle || 0, stopAngle: stopAngle || 360 }).addTo(this.map));
            this.map.setView(latLng, zoom || 9);

            setTimeout(() => this.map.invalidateSize(), 100);
          })
        } else {
          let { latLng, radius, startAngle, stopAngle } = nextProps.circle;
          if ((!!startAngle || +startAngle === 0) && (!!stopAngle || +stopAngle === 0) && +startAngle === +stopAngle) {
            startAngle -= 5;
            stopAngle += 5;
          }
          this.circle = L.semiCircle(latLng, { radius, startAngle: startAngle || 0, stopAngle: stopAngle || 360 }).addTo(this.map);
          this.map.setView(latLng, zoom || 9);

          setTimeout(() => this.map.invalidateSize(), 100);
        }
      }
    }

    if ((this.props.polylines === null && nextProps.polylines) || (this.props.polylines && nextProps.polylines === null) || !_.isEqual(toJS(this.props.polylines), toJS(nextProps.polylines))) {
      if (this.polylines) {
        this.polylines.forEach(polyline => {
          this.map.removeLayer(polyline);
        })
      }

      if (nextProps.polylines) {
        this.polylines = [];

        nextProps.polylines.forEach(polyline => {
          this.polylines.push(L.polyline(polyline.latLngs.map((latLng) => ({ lat: latLng[0], lng: latLng[1] })), {
            color: polyline.color
          }).addTo(this.map));
        });
      }
    }

    if ((this.props.geojson === null && nextProps.geojson) || (this.props.geojson && nextProps.geojson === null) || !_.isEqual(toJS(this.props.geojson), toJS(nextProps.geojson))) {
      if (this.geojson)
        this.map.removeLayer(this.geojson);

      if (nextProps.geojson) {
        this.geojson = L.geoJSON(nextProps.geojson).addTo(this.map);
        this.map.fitBounds(this.geojson.getBounds());
      }
    }

    if (+lat !== +center.lat || +lng !== +center.lng) {
      this.map.panTo(new L.LatLng(lat, lng));
    }
  }

  componentWillUnmount() {
    this.dispose();
    let mapChildren = document.getElementById(`map-${this.props.id}-children`);
    events.forEach(event => {
      mapChildren.removeEventListener(event, this.stopPropagation);
    });
  }

  renderCustomControl = (position) => (control) => {
    L.Control.MyControl = L.Control.extend({
      onAdd: (map) => {

        var el = L.DomUtil.create('div', 'leaflet-bar my-control');

        el.innerHTML = renderToStaticMarkup(control.markup);

        L.DomEvent.on(
          el, // HTMLElement
          'click', // String with event names
          function (ev) {
            L.DomEvent.stopPropagation(ev);

            if (control.onClick)
              control.onClick(ev)
          } // Handler function);
        );

        L.DomEvent.on(
          el, // HTMLElement
          'dblclick', // String with event names
          function (ev) {
            L.DomEvent.stopPropagation(ev);

            if (control.onDoubleClick)
              control.onDoubleClick(ev)
          } // Handler function);
        );

        return el;
      },

      onRemove: function (map) {
        L.DomEvent.off();

        // Nothing to do here
      }
    });

    L.control.myControl = function (opts) {
      return new L.Control.MyControl(opts);
    }

    L.control.myControl({
      position
    }).addTo(this.map);
  }

  makeDraggable = (popup) => {
    let pos = this.map.latLngToLayerPoint(popup.getLatLng());

    L.DomUtil.setPosition(popup._wrapper.parentNode, pos);

    const draggable = new L.Draggable(popup._container, popup._wrapper);

    draggable.enable();

    const map = this.map

    draggable.on('dragend', function () {
      let pos = map.layerPointToLatLng(this._newPos);
      popup.setLatLng(pos);
    });
  }

  stopPropagation = event => {
    event.stopPropagation();
  };

  @action
  pushMarkers(markers) {
    markers.map(marker => {
      let markerIcon;
      const isMarkerSelected = !!this.props.selectedMarker && this.props.selectedMarker === marker.station_id;
      const icon = (() => {
        if (marker.smallerIcon && this.map.getZoom() <= 6) return marker.smallerIcon;
        if (marker.largerIcon && this.map.getZoom() > 8) return marker.largerIcon;
        return marker.icon;
      })();

      const customIcon = L.icon({
        iconUrl: '/markers/marker-blue.png',  
        iconSize: [32, 32],  
        iconAnchor: [16, 32], 
        popupAnchor: [0, -10], 
      });

      if (!!icon) {
        markerIcon = L.marker(marker.position, { icon: L.divIcon({ html: isMarkerSelected && !!marker.iconHighlighted ? marker.iconHighlighted : icon }) });
      } else {
        markerIcon = L.marker(marker.position, {icon:customIcon});
      }

      if (!!marker.popupBox) {
        markerIcon.bindPopup(marker.popupBox, {
          autoPan: false,
          closeOnClick: false, autoClose: false
        });
      }

      markerIcon.on('mouseover', () => {
        if (!!marker.popupBox) {
          markerIcon.openPopup();
        }
        if (!!this.props.onMarkerOver) this.props.onMarkerOver(marker);
      });

      markerIcon.on('click', () => {
        if (!!this.props.onMarkerClick) {
          this.props.onMarkerClick(marker);
        }
        if (marker.draggable) {
          const sameDraggable = this.draggables.find(draggable => draggable.id === marker.id);
          if (sameDraggable && sameDraggable.popup && !sameDraggable.popup.isOpen()) {
            sameDraggable.popup.openOn(this.map)
          }
        }
      });

      if (marker.draggable) {
        const sameDraggable = this.draggables.find(draggable => draggable.id === marker.id);

        if (!sameDraggable) {
          const popup = L.popup({
            closeOnClick: false,
            autoClose: false
          })
            .setLatLng(marker.position)
            .setContent(marker.draggable)
            .openOn(this.map);

          this.makeDraggable(popup);

          this.draggables = [...this.draggables, { id: marker.id, popup }];
        } else if (sameDraggable && sameDraggable.popup && !sameDraggable.popup.isOpen()) {
          sameDraggable.popup.openOn(this.map)
        }
      }

      let prevDraggable = this.draggables.find(item => item.id === marker.id)
      if (!!prevDraggable && !!prevDraggable.popup && prevDraggable.popup.isOpen()) {
        prevDraggable.popup.setContent(marker.draggable);
      }

      this.map.addLayer(markerIcon);
      this.markerIcons.push({ id: marker.id, markerIcon });
    });
    if (markers.length > 2 && !!this.draggables.length) this.map.fitBounds(L.latLngBounds(markers.map(marker => marker.position)));
  }

  render() {
    return (
      <div id={this.props.id} style={{ height: this.props.height || '60vh', width: this.props.width || '100%' }} className='map'>
        {this.props.isLoading && <div style={{
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          position: 'relative',
          zIndex: 1000,
        }}>
          <ReactSpinner />
        </div>}
        <div id={`map-${this.props.id}-children`} className='map-children'>
          {this.props.children}
        </div>
      </div>
    );
  }
}

LeafletMap.wrappedComponent.propTypes = {
  id: PropTypes.string.isRequired,
  markers: PropTypes.array.isRequired, // [{id, position: [lat, lng], icon, popupBox}]
  center: PropTypes.object.isRequired, // [lat, lng]
  height: PropTypes.string,
  width: PropTypes.string,
  isLoading: PropTypes.bool
};

export default LeafletMap;



// WEBPACK FOOTER //
// ./src/components/LeafletMap.js